import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=5dd9ea02&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=ts&"
export * from "./pc.vue?vue&type=script&lang=ts&"
import style0 from "./pc.vue?vue&type=style&index=0&id=5dd9ea02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9ea02",
  null
  
)

export default component.exports